import { PushNotifications } from '@capacitor/push-notifications';
import { authHeader } from '../api/authHeader';
import { handleResponse } from '../api/handleResponse';

export const pushNotificationService = {
    init() {
        if (typeof window !== 'undefined' && window.Capacitor && window.Capacitor.isNativePlatform()) {
            this.registerPush();
        }
    },

    async registerPush() {
        let permStatus = await PushNotifications.checkPermissions();

        if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
            return;
        }

        PushNotifications.addListener('registration', (token) => {
            this.sendTokenToBackend(token.value);
        });

        PushNotifications.addListener('registrationError', (error) => {
            alert('Error on registration: ' + JSON.stringify(error));
        });

        PushNotifications.addListener('pushNotificationReceived', (notification) => {
            // When a notification is received while the app is in the foreground
            console.log('Push received: ' + JSON.stringify(notification));
        });

        PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
            // When the user taps on a notification
            console.log('Push action performed: ' + JSON.stringify(notification));
        });

        await PushNotifications.register();
    },

    sendTokenToBackend(token) {
        const requestOptions = {
            method: 'POST',
            headers: authHeader({ 'Content-Type': 'application/json' }),
            body: JSON.stringify({ token: token })
        };

        return fetch(process.env.REACT_APP_API_URL + '/register-device', requestOptions)
            .then(handleResponse)
            .catch(error => {
                console.error('Error sending token to backend:', error);
            });
    }
};
